import { Col, Form, Input, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import BaseWebEditUniversal, { BaseWebEditUniversalProps } from '../system/BaseWebEditUniversal';
import fetchApi from '../system/fetchApi';
import objectHandle from '../../../utilsTs/baseLib/objectHandle';
import getList from '../../universal/getList';
import antdMessage from '../system/antdMessage';

const FilesServerEdit = (props: BaseWebEditUniversalProps) => {
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    const rootDirectoryData = [{
        id: '/api',
        name: '/api'
    }, {
        id: '/test',
        name: '/test'
    }];
    const [defaultServiceIdData, setDefaultServiceIdData] = useState<any>();
    /** 地址模式类型 */
    type urlModelType = 'apiUrl' | 'manageApiUrl';
    /**
     * 获取文件服务器地址
     * @param obj
     * @param urlModel 地址模式类型
     */
    const getFilesServerUrl = (obj: any, urlModel?: urlModelType) => {
        const { serverUrl, port, rootDirectory, manageApiUrl, apiUrl } = obj;
        const filesServerManageUrl = serverUrl + (objectHandle.isEmpty(port, true) === false ? (':' + port) : '') +
            rootDirectory + (urlModel === 'apiUrl' ? apiUrl : manageApiUrl);
        fetchApi.GET(
            filesServerManageUrl, {
            query: {
                apiId: 'service',
                apiExtend: 'showList'
            }
        }
        ).then(filesRes => {
            if (filesRes.success) {
                setDefaultServiceIdData(filesRes.data);
            }
            else {
                setDefaultServiceIdData(undefined);
                antdMessage('error', '错误', { description: '无法获取服务号列表!' });
            }
        }).catch((err) => {
            setDefaultServiceIdData(undefined);
            antdMessage('error', '错误', { description: '无法获取服务号列表!' + err.message });
        });
    };
    /**
     * 设置serviceIds
     */
    const setServiceIds = () => {
        const serverUrl = form.getFieldValue('serverUrl');
        const port = form.getFieldValue('port');
        const rootDirectory = form.getFieldValue('rootDirectory');
        const manageApiUrl = form.getFieldValue('manageApiUrl');
        const apiUrl = form.getFieldValue('apiUrl');
        getFilesServerUrl({
            serverUrl, port, rootDirectory, manageApiUrl, apiUrl
        }, 'manageApiUrl')
    }

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then(async (res: any) => {
                if (res.success === true) {
                    getFilesServerUrl(res.data, 'manageApiUrl');
                }
            })
        }
    }, []);

    let extendProps: BaseWebEditUniversalProps = {
        ...props,
        formOptions: {
            children: (options) => {
                return (<Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="名称"
                            name="serverName"
                            rules={[{ required: true, message: '请输入服务器名称!' }]}>
                            <Input
                                placeholder="服务器名称" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="地址"
                            name="serverUrl">
                            <Input
                                placeholder="http://localhost"
                                onChange={() => setServiceIds()} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="端口"
                            name="port">
                            <Input
                                placeholder="3009"
                                onChange={() => setServiceIds()}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="根目录"
                            name="rootDirectory"
                            rules={[{ required: true, message: '请选择根目录!' }]}>
                            <Select
                                showSearch
                                placeholder="根目录"
                                optionFilterProp="children"
                                onChange={() => setServiceIds()}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(rootDirectoryData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="apiUrl"
                            name="apiUrl">
                            <Input
                                placeholder="/file/service"
                                onChange={() => setServiceIds()} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="管理apiUrl"
                            name="manageApiUrl">
                            <Input
                                placeholder="/manage/service"
                                onChange={() => setServiceIds()} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="默认服务号"
                            name="defaultServiceId">
                            <Select
                                showSearch
                                placeholder="默认服务号"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(defaultServiceIdData, { itemName: 'serviceName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="默认"
                            name="isDefault"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>)
            }
        },
    };

    return (
        <BaseWebEditUniversal ref={ref} {...extendProps} />
    )
}

export default FilesServerEdit;